module.exports = __webpack_public_path__ + "static/media/cpp.b6ed13e5.png";